/*
  COMPONENT: Product Recommendations Runtime

  Owns:
  - Async loading for Shopify product recommendations sections

  Does not own:
  - Product recommendation algorithm
  - Product card behavior
*/

(() => {
  const parser = new DOMParser();

  async function loadRecommendations(section) {
    const url = section.dataset.url;
    if (!url || section.dataset.loaded === 'true') return;
    section.dataset.loaded = 'true';

    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) return;

    const html = await response.text();
    const doc = parser.parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-product-recommendations]');
    if (!next) return;

    if (next.innerHTML.trim()) {
      section.innerHTML = next.innerHTML;
      window.CurtisWishlist?.sync(section);
      window.CurtisTheme?.initialize(section);
      window.CurtisMotion?.initialize(section);
    } else {
      section.hidden = true;
    }
  }

  function initializeProductRecommendations(root = document) {
    root.querySelectorAll('[data-product-recommendations]').forEach((section) => {
      loadRecommendations(section).catch(() => {
        section.hidden = true;
      });
    });
  }

  initializeProductRecommendations();
  document.addEventListener('shopify:section:load', (event) => initializeProductRecommendations(event.target));
})();
